import { render } from "./TransferTicketModal.vue?vue&type=template&id=04f89f47"
import script from "./TransferTicketModal.vue?vue&type=script&lang=js"
export * from "./TransferTicketModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__